// extracted by mini-css-extract-plugin
export default {"root":"ManufacturerSelect_root__CfzHj","container":"ManufacturerSelect_container__jgDCk"};